import { ReportTemplatePreset } from '../services/agent-builder.interface';

export type { ReportTemplatePreset };

/** BUNDLED FALLBACK copy of the report starter presets. The server owns the
 *  list (GET /report-templates, surfaced via ReportTemplatePresetsService);
 *  this copy is used only when the server sends none (offline / old API /
 *  empty). Curate new presets server-side, not here. */
export const REPORT_TEMPLATE_PRESETS: ReportTemplatePreset[] = [
  {
    key: 'security-incident',
    name: 'Security incident',
    blurb: 'Post-incident report for security teams and leadership',
    title: 'Security Incident Report',
    sections: [
      'Executive summary',
      'Incident timeline',
      { title: 'Affected systems', chartKind: 'table' },
      'Root cause',
      'Containment & remediation',
      'Recommendations',
    ],
  },
  {
    key: 'case-summary',
    name: 'Case summary',
    blurb: 'Full picture of a support case for handovers and escalations',
    title: 'Case Summary',
    sections: [
      'Case overview',
      'Customer impact',
      'Investigation so far',
      { title: 'Case activity', chartKind: 'table' },
      'Next steps & owners',
    ],
  },
  {
    key: 'sales-pipeline',
    name: 'Sales pipeline',
    blurb: 'Pipeline review for sales leadership',
    title: 'Sales Pipeline Review',
    sections: [
      'Executive summary',
      { title: 'Pipeline by stage', chartKind: 'bar' },
      { title: 'Quarter-over-quarter trend', chartKind: 'line' },
      'At-risk opportunities',
      'Recommended actions',
    ],
  },
  {
    key: 'compliance-audit',
    name: 'Compliance audit',
    blurb: 'Audit findings with severity breakdown for compliance owners',
    title: 'Compliance Audit Report',
    sections: [
      'Scope & methodology',
      { title: 'Findings by severity', chartKind: 'pie' },
      { title: 'Findings detail', chartKind: 'table' },
      'Gaps & exceptions',
      'Remediation plan',
    ],
  },
  {
    key: 'weekly-ops',
    name: 'Weekly ops',
    blurb: 'Recurring operational health summary for the team',
    title: 'Weekly Operations Summary',
    sections: [
      { title: 'Headline metric', chartKind: 'kpi' },
      'Highlights',
      { title: 'Volume trend', chartKind: 'line' },
      'Issues & blockers',
      'Focus for next week',
    ],
  },
  {
    key: 'exec-brief',
    name: 'Executive brief',
    blurb: 'One-page decision-ready brief for executives',
    title: 'Executive Brief',
    sections: [
      'Summary',
      { title: 'Key numbers', chartKind: 'kpi' },
      'Risks',
      'Decision needed',
    ],
  },
];
